import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-nowrap-layout',
  templateUrl: './nowrap-layout.component.html',
  styleUrls: ['./nowrap-layout.component.scss']
})
export class NowrapLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
